<template>
  <Loading v-if="loading" />
  <div class="changeLang">
    <div class="changeLang__title">
      <p class="title">
        {{ $t('lang') }}
      </p>
    </div>
    <FormKit
      type="form"
      id="lang-form"
      v-model="formData"
      :actions="false"
      @submit="submitHandler"
    >
      <Dropdown
        class="dropdown-lang"
        :selectedOption="langsDropdown.selectedOption"
        :options="langsDropdown.options"
        :label="$t('desktopLang')"
        @selectOption="selectLanguage"
      />
    </FormKit>
    <Button
      class="changeLang-btn"
      variant="filled"
      :title="$t('save')"
      @click="submitForm"
    />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

import {
  langsEn,
  langsFi,
  langsSv,
  langsNo,
  optionsLanguageEn,
  optionsLanguageFi,
  optionsLanguageSv,
  optionsLanguageNo
} from '@/services/languageService';
import { Option } from '@/types';

@Options({
  name: 'ChangeLang',
  components: {
    Loading
  },
  data() {
    return {
      formData: {
        lang: ''
      },
      langsDropdown: {
        selectedOption: {
          label: '',
          value: ''
        },
        options: []
      },
      loading: false
    };
  },
  computed: {
    ...mapState('account', ['user'])
  },
  methods: {
    ...mapActions('account', ['changeLang', 'getUserProfile']),
    initLanguage() {
      const optionsMappings: { [key: string]: Option[] } = {
        en: optionsLanguageEn,
        fi: optionsLanguageFi,
        sv: optionsLanguageSv,
        no: optionsLanguageNo
      };

      const userLanguage = this.user?.appLanguage;
      if (userLanguage && optionsMappings[userLanguage]) {
        this.langsDropdown.options = optionsMappings[userLanguage];
      }
    },
    selectLanguage(option: Option) {
      this.langsDropdown.selectedOption = option;
    },
    async submitHandler() {
      this.loading = true;

      const payload = {
        lang: this.langsDropdown.selectedOption.value
      };

      await this.changeLang(payload);
      await this.getUserProfile();
      this.$i18n.locale = this.langsDropdown.selectedOption.value;
      this.$formkit.reset('lang-form');
      this.loading = false;
    },
    submitForm() {
      this.$formkit.submit('lang-form');
    }
  },
  watch: {
    user() {
      if (this.user && this.user.appLanguage) {
        this.initLanguage();

        if (this.user?.appLanguage === 'en') {
          this.langsDropdown.selectedOption = {
            label: langsEn[this.user.appLanguage],
            value: this.user.appLanguage
          };
        }

        if (this.user?.appLanguage === 'fi') {
          this.langsDropdown.selectedOption = {
            label: langsFi[this.user.appLanguage],
            value: this.user.appLanguage
          };
        }

        if (this.user?.appLanguage === 'sv') {
          this.langsDropdown.selectedOption = {
            label: langsSv[this.user.appLanguage],
            value: this.user.appLanguage
          };
        }

        if (this.user?.appLanguage === 'no') {
          this.langsDropdown.selectedOption = {
            label: langsNo[this.user.appLanguage],
            value: this.user.appLanguage
          };
        }
      }
    }
  }
})
export default class ChangeLang extends Vue {}
</script>

<style lang="scss" scoped>
.changeLang {
  .changeLang__title {
    position: relative;
    margin-top: 40px;
    margin-bottom: 32px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $sixteenSize;
      color: $main-text;
    }
    &::after {
      content: '';
      position: absolute;
      top: 9px;
      left: 80px;
      width: 100%;
      height: 1px;
      background: $ligher-grey;
    }
    &::before {
      content: '';
      position: absolute;
      top: 7px;
      left: 80px;
      width: 5px;
      height: 5px;
      border-radius: 8px;
      background: $ligher-grey;
    }
  }
  .formkit-form {
    .dropdown-lang {
      height: 48px;
      width: 375px;
      .dropdown {
        height: 46px;
      }
    }
  }
  .changeLang-btn {
    margin-top: 30px;
  }
}
</style>
